import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily:
      '"FS PFBeauSansPro", "Inter", "FS Magistral", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    h1: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 600,
    },
    subtitle1: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 500,
    },
    subtitle2: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 400,
    },
    button: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 500,
      textTransform: 'none',
    },
    caption: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 400,
    },
    overline: {
      fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
      fontWeight: 400,
    },
  },
  palette: {
    primary: {
      main: '#fc773aff',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f5f5f5',
    },
    background: {
      default: '#FFF',
      paper: '#ffffff',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@global': {
          '*': {
            fontFamily:
              '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif !important',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            fontFamily:
              '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
          },
          '& .MuiInputLabel-root': {
            fontFamily:
              '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
        },
        secondary: {
          fontFamily: '"FS PFBeauSansPro", "Inter", "FS Magistral", sans-serif',
        },
      },
    },
  },
});

export default theme;
